import { useEffect, useRef, useState } from "react";
import TitleWidget from "src/components/widgets/TitleWidget";
import {
  drawWidgets,
  ItemTypeProperties,
} from "src/components/widgets/WidgetTypes";
import styles from "./DashboardEditorPage.module.css";
import Dashboard, { Item } from "src/components/dashboard/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import {
  editDashboardSave,
  fetchGridStackLists,
} from "src/thunks/dashboardThunk";
import {
  editDashboardItems,
  getCurrentDashboardMode,
  removeItemFromDashboard,
  setCurrentDashboardMode,
  setCurrentStackListId,
} from "src/store/dashboardSlice";
import apiServices from "src/api/apiService";
import { Eye, Pencil } from "lucide-react";
import ResponsiveColorWidget from "src/components/debug/ResponsiveColorWidget";

const DashboardEditorPage = () => {
  let newWidgets = [
    { id: "item-bt", w: 2, h: 1, type: "text", itemdata: "item 2" },
    {
      id: "item-543543t",
      w: 3,
      h: 1,
      type: "text",
      itemdata: "item 3",
    },
    { id: "item-sgrsg", w: 4, h: 1, type: "text", itemdata: "item 4" },
    {
      id: "item-aiorge",
      w: 5,
      h: 1,
      type: "text",
      itemdata: "item 5",
    },
    {
      id: "item-aiofffrge",
      w: 6,
      h: 2,
      type: "calendar",
      itemdata: "Lionel Kayasith",
    },
    { id: "item-chat", w: 1, h: 1, type: "chat", itemdata: "Lionel Kayasith" },
    {
      id: "context",
      w: 2,
      h: 2,
      type: "context",
      context: { title: "new context", sections: [] },
    },
    {
      id: "badges",
      w: 2,
      h: 3,
      type: "badges",
    },
    {
      id: "datavis",
      w: 3,
      h: 3,
      type: "datavis",
    },
    {
      id: "title",
      w: 3,
      h: 3,
      type: "text",
    },
    {
      id: "threed",
      w: 3,
      h: 3,
      type: "threed",
    },
    // { id: "pachinkoa", y: 1, x: 0, w: 1, h: 1, type: "pachinko" },
    // { id: "item-5a", y: 3, x: 4, w: 3, h: 2, type: "calendar", content: "a" },
  ];

  const [hasFetched, setHasFetched] = useState(false);
  const dbRef = useRef(null);
  const sidepanelRef = useRef(null);
  const [dbHeight, setDbHeight] = useState(10);
  const [dbSettings, setDbSettings] = useState(null);
  const dispatch = useDispatch();

  const dashboardRef = useRef();

  const dashboardList = useSelector((state) => state.dashboard.gridStackList);
  const dashboardListStatus = useSelector(
    (state) => state.dashboard.gridStackListStatus
  );
  const errorMessage = useSelector((state) => state.dashboard.error);

  const currentDashboardId = useSelector(
    (state) => state.dashboard.currentStackListId
  );
  //a ref to use on things with closed state like listeners etc.
  const dashboardIdRef = useRef(currentDashboardId);
  useEffect(() => {
    dashboardIdRef.current = currentDashboardId;
  }, [currentDashboardId]);
  const dashboardListRef = useRef(dashboardList);
  useEffect(() => {
    dashboardListRef.current = dashboardList;
  }, [dashboardList]);

  const items = useSelector(
    (state) =>
      state.dashboard.gridStackList.find((d) => d.id === currentDashboardId)
        ?.dashboardData || []
  );
  const currentDashboardMode = useSelector(getCurrentDashboardMode);

  const updateSidepanelHeight = () => {
    if (dbRef.current) {
      setDbHeight(dbRef.current.offsetHeight);
    }
  };

  let itemStyles = (item) => {
    if (dbSettings == null) return null;
    return {
      width: `${dbSettings.itemWidth * item.w}px`,
      height: `${dbSettings.itemHeight * item.h}px`,
      overflow: "hidden",
      borderRadius: "8px",
      border: "2px solid red",
    };
  };

  const removeItemHandler = (item) => {
    dispatch(
      removeItemFromDashboard({
        itemId: item.id,
        dashboardId: currentDashboardId,
      })
    );
  };

  const onDashboardSelectHandler = (dashboardSelectedId) => {
    dispatch(setCurrentStackListId(dashboardSelectedId));
  };

  const updateItems = async () => {
    console.log(`editing ${dashboardIdRef.current}`);
    let savedItems = dashboardRef.current.saveLayout();
    let updatedItems = [];
    let currentItemsCopy = dashboardListRef.current.find(
      (dashboard) => dashboard.id === dashboardIdRef.current
    ).dashboardData;
    console.log("CURRENT");
    console.log(currentItemsCopy);
    savedItems.map(({ id, x, y, w, h }) => {
      let isNewItem = true;
      currentItemsCopy.map((item) => {
        if (item.id === id) {
          isNewItem = false;

          updatedItems.push({ ...item, x: x, y: y, w: w, h: h });
        }
        return true;
      });
      if (isNewItem) {
        let newWidgetItem = newWidgets.find((newItem) => {
          return newItem.id === id;
        });
        updatedItems.push({
          ...newWidgetItem,
          id: `item-${Date.now()}`,
          x: x,
          y: y,
          w: w,
          h: h,
        });
      }
      return {
        id,
        x,
        y,
        w,
        h,
      };
    });

    console.log(updatedItems);
    dispatch(
      editDashboardItems({
        dashboardId: dashboardIdRef.current,
        items: updatedItems,
      })
    );
  };

  const addItemHandler = (nitem) => {
    updateItems();
  };

  useEffect(() => {
    dispatch(setCurrentStackListId(null));
    fetchDashboards();
    updateSidepanelHeight();
    window.addEventListener("resize", updateSidepanelHeight); // Update on resize
    return () => {
      window.removeEventListener("resize", updateSidepanelHeight); // Cleanup on unmount
    };
  }, []);
  useEffect(() => {
    dispatch(setCurrentDashboardMode("edit"));
  }, [dispatch]);

  useEffect(() => {
    updateSidepanelHeight();
    if (hasFetched && dashboardList.length > 0 && currentDashboardId === null) {
      dispatch(setCurrentStackListId(dashboardList[0].id));
      updateSidepanelHeight();
    }
  }, [hasFetched, dashboardList, currentDashboardId]);

  const fetchDashboards = async () => {
    if (dashboardList.length === 0 && dashboardListStatus === "idle") {
      dispatch(fetchGridStackLists()).then(() => {
        setHasFetched(true); // Mark as fetched when data is retrieved
      });
    } else if (dashboardListStatus === "succeeded") {
      setHasFetched(true);
    }
  };

  let currentDashboardData = dashboardList.find(
    (dashboard) => dashboard.id === currentDashboardId
  )?.dashboardData;
  return (
    <>
      {dashboardListStatus === "loading" && <p>Loading your dashboards...</p>}
      {dashboardListStatus === "failed" && <p>Error loading, {errorMessage}</p>}
      {dashboardListStatus === "succeeded" && (
        <div>
          <div
            id="trash"
            style={{
              padding: "8px",
              backgroundColor: "red",
              height: "3rem",
              width: "3rem",
            }}
          >
            tr
          </div>
          <button
            className="btn btn-active btn-primary"
            onClick={async (e) => {
              await updateItems();
              dispatch(
                editDashboardSave({
                  dashboardId: currentDashboardId,
                  dashboardData: dashboardList.find(
                    (dashboard) => dashboard.id === currentDashboardId
                  ).dashboardData,
                })
              );
            }}
          >
            Save dashboard
          </button>
          <br />
          <ResponsiveColorWidget />
          <select
            value={currentDashboardId}
            onChange={(e) => {
              onDashboardSelectHandler(e.target.value);
            }}
          >
            {dashboardList.map((dashboard) => {
              return (
                <option key={dashboard.id} value={dashboard.id}>
                  {dashboard.title} {dashboard.id}
                </option>
              );
            })}
          </select>
          <div className="row" style={{ alignItems: "stretch" }}>
            <div
              className={`sidepanel ${styles.sidepanel}`}
              ref={sidepanelRef}
              style={{ maxHeight: dbHeight }}
            >
              Sidepanel list.
              {newWidgets.map((item, i) => {
                return (
                  <div
                    className={`grid-stack-item ${styles.draggable}`}
                    style={itemStyles(item)}
                    gs-w={item.w}
                    gs-h={item.h}
                    gs-min-w={ItemTypeProperties[item.type]?.minW}
                    gs-min-h={ItemTypeProperties[item.type]?.minH}
                    key={item.id + i}
                    gs-id={item.id}
                  >
                    <div className="grid-stack-item-content">
                      <Item item={item} sidelist={true} />
                    </div>
                  </div>
                );
              })}
            </div>

            <div className={`db ${styles.db}`} ref={dbRef}>
              <div>
                <button
                  onClick={(e) => {
                    let toggleMode =
                      currentDashboardMode === "view" ? "edit" : "view";
                    dispatch(setCurrentDashboardMode(toggleMode));
                  }}
                >
                  {currentDashboardMode === "view" && <Eye size={20} />}
                  {currentDashboardMode === "edit" && <Pencil size={20} />}
                </button>
              </div>
              {dashboardList.length > 0 &&
                dashboardList.find(
                  (dashboard) => dashboard.id === currentDashboardId
                ) && (
                  <Dashboard
                    ref={dashboardRef}
                    items={items}
                    getDashboardSettings={(settings) => {
                      setDbSettings(settings);
                    }}
                    addItem={(item) => addItemHandler(item)}
                    removeItem={(item) => removeItemHandler(item)}
                    dashboardMode={"EDIT"}
                  />
                )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardEditorPage;
